import React, { PropTypes } from "react";
import FeedbackCarousel from "../../../containers/FeedbackCarousel";

const UpcomingLandingWebinars = ({
  webinars,
  scrollRootRef,
  scrollBack,
  scrollForward,
  showBack,
  showForward,
  nextPage,
  pagination,
  count,

  isMobile,
}) => (
  <div>
    <div className={`container_upcoming row landing_flex`}>
      {/* <h2 id="upcoming" className="section_upcoming_title">UPCOMING WEBINARS {count ? `(${count})` : '(0)'}</h2> */}
      <div>
        <h2 id="upcoming" className="landing_upcoming_title">
          <span>UPCOMING</span> <span>Webinars</span>
        </h2>
        {!isMobile && (
          <FeedbackCarousel style={{ width: "400px", marginTop: "16px" }} />
        )}
      </div>
      <div className={`landing_webinars`}>
        {showBack && (
          <div className="left" onClick={scrollBack}>
            {"<"}
          </div>
        )}
        <div className="webinars" ref={scrollRootRef}>
          {typeof webinars === "function" ? webinars() : webinars}
        </div>
        {showForward && (
          <div className="right" onClick={scrollForward}>
            {">"}
          </div>
        )}
      </div>
    </div>

    {/* {pagination && <a className="more_item" href="javascript:void(0)" onClick={nextPage}>LOAD MORE</a>} */}
    {!webinars.length && (
      <p className="has_no_items">There are no upcoming webinars currently</p>
    )}
  </div>
);

UpcomingLandingWebinars.propTypes = {
  webinar: PropTypes.obj,
};

export default UpcomingLandingWebinars;



// WEBPACK FOOTER //
// ./src/components/Dashboard/UpcomingWebinars/UpcomingLandingWebinars.js